
import { FC, useContext, useState } from "react";
import { GroupBase, OptionsOrGroups } from "react-select";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import { format, parse } from "date-fns";
import DatePicker from "react-datepicker";
import ReactInputMask from "react-input-mask";
import { useDebouncedCallback } from "use-debounce";
import HubInputField from "src/components/inputType";
import { DRUG_NAME, StatisticsProps } from "./types";
import { PatientFilterState } from "src/pages/actionDashboard/types";
import { isZilrettaUser } from "src/helpers";
import { AuthContext } from "src/context/authContext";
// import ActionDashBoardStatsReports from "../manufacturer/actionDashBoardStatsReport";
// import StatsReports from "../manufacturer/statsReports";




const ActionDashBoardFilter: FC<StatisticsProps> = ({ updateQueryParams, defaultQueryParams, doctorDropdown, practiceDropdown }): JSX.Element => {
  const [filteredDocListing, updatedFilteredDocListing] = useState<{ id: number; name: string; }[]>([])
  const [filteredPracticeListing, updatedFilteredPracticeListing] = useState<{ id: number; name: string; }[]>([])

  const { control, handleSubmit, reset, getValues, watch } = useForm<PatientFilterState>({
    mode: 'all',
    defaultValues: {
        ...defaultQueryParams,
        ...(defaultQueryParams && defaultQueryParams.drug_id === "" ? {
            drug_id: "All Product"
        } : {})
    },
  });

  const start_date = watch("start_date");
  const end_date = watch("end_date");
  const {userData} = useContext(AuthContext)


  const searchForStats = (values: PatientFilterState) => {
    //console.log("Values ......",values)
    const updatedValues = {
      ...defaultQueryParams,
      ...values,
      global_doctor_id:
        values.global_doctor_id ?
          (typeof values.global_doctor_id === "string" ? values.global_doctor_id : (values.global_doctor_id as unknown as { value: string; label: string; }).value)
          : "",
          drug_id:
                values.drug_id
                    ? (typeof values.drug_id === "string"
                        ? values.drug_id === "All Product"
                            ? ""
                            : values.drug_id
                        : (values.drug_id as { value: string; label: string }).value === "All Product"
                            ? ""
                            : (values.drug_id as { value: string; label: string }).value)
                    : "",
      practice_id:
        values.practice_id ?
          (typeof values.practice_id === "string" ? values.practice_id : (values.practice_id as unknown as { value: string; label: string; }).value)
          : "",
    };

    updateQueryParams(updatedValues, false);
  };


  //:- Filtering practice from api recieved listing
  const filterPractice = (search: string) => {
    if (search.length >= 2) {
      updatedFilteredPracticeListing(
        practiceDropdown.filter((prac) => prac.name.toLowerCase().includes(search.toLowerCase()))
      )
    }
  };
  const debouncedFilterPractice = useDebouncedCallback(filterPractice, 500);

  //:- Filtereing doctor from api recieved listing
  const filterDoctor = (search: string) => {
    if (search.length >= 2) {
      updatedFilteredDocListing(
        doctorDropdown.filter((doc) => doc.name.toLowerCase().includes(search.toLowerCase()))
      )
    }
  };
  const debouncedFilterDoctor = useDebouncedCallback(filterDoctor, 500);


  const clearFormData = () => {
    console.log("defaultQueryParams......",defaultQueryParams)
    const values = {
      ...defaultQueryParams,
      start_date: format((new Date()).setDate((new Date()).getDate() - 15), "yyyy-MM-dd"),
      end_date: format((new Date()).setDate((new Date()).getDate() + 1), "yyyy-MM-dd"),
      practice_id: "",
      global_doctor_id: "",
      case_id: "",
      global_patient_id: "",
      //drug_id:""
      drug_id: isZilrettaUser(userData) ? 'zilretta' :  "All Product"
    };
    reset(values);
    updatedFilteredDocListing([]);
    updatedFilteredPracticeListing([]);
    updateQueryParams(getValues(), true);
  };

    return (
        <form className="row g-2 filters" onSubmit={handleSubmit(searchForStats)}>
            { <div className="col product-field mb-2">
                <Controller
                    name="drug_id"
                    control={control}
                    defaultValue={""}
                    render={({ field }) => (
                        <Select
                            id="drug_id"
                            placeholder="Select Drug"
                            isClearable={false}
                            isSearchable={false}
                            isDisabled={isZilrettaUser(userData)}
                            options={
                                DRUG_NAME.length > 0
                                    ? DRUG_NAME.map((item) => ({
                                        value: item.value,
                                        label: item.label,
                                    }))
                                    : []
                            }
                            // current value ko properly map karna zaroori hai
                            value={
                                field.value
                                    ? DRUG_NAME.find((item) => item.value === field.value)
                                    : null
                            }
                            onChange={(selectedOption) =>
                                field.onChange(selectedOption ? selectedOption.value : "")
                            }
                            onBlur={field.onBlur}
                        />
                    )}
                />

            </div>}
            <div className="col date-field mb-2">
                <Controller
                    name="start_date"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                        <DatePicker
                            selected={field.value.length > 0 ? parse(field.value, "yyyy-MM-dd", new Date()) : null}
                            onChange={(date) => date ? field.onChange(format(date, "yyyy-MM-dd")) : ""}
                            customInput={
                                <ReactInputMask mask="99/99/9999">
                                    {(inputProps: {} = { className: "form-control" }) =>
                                        <>
                                            <input {...inputProps} />
                                        </>
                                    }
                                </ReactInputMask>
                            }
                            className="form-control" wrapperClassName="w-100"
                            placeholderText="mm/dd/yyyy"
                            dateFormat="MM/dd/yyyy"
                            showMonthDropdown
                            showYearDropdown
                            maxDate={end_date ? new Date(end_date) : undefined}
                        />
                    )}
                />
            </div>
            <div className="col date-field mb-2">
                <Controller
                    name="end_date"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                        <DatePicker
                            selected={field.value.length > 0 ? parse(field.value, "yyyy-MM-dd", new Date()) : null}
                            onChange={(date) => date ? field.onChange(format(date, "yyyy-MM-dd")) : ""}
                            customInput={
                                <ReactInputMask mask="99/99/9999">{(inputProps: {} = { className: "form-control" }) =>
                                    <>
                                        <input {...inputProps} />
                                    </>
                                }
                                </ReactInputMask>
                            }
                            className="form-control" wrapperClassName="w-100"
                            placeholderText="mm/dd/yyyy"
                            dateFormat="MM/dd/yyyy"
                            showMonthDropdown
                            showYearDropdown
                            minDate={start_date ? new Date(start_date) : undefined}
                        />
                    )}
                />
            </div>
            <div className="col mb-2">
                <Controller
                    name="practice_id"
                    control={control}
                    render={({ field }) => (
                        <Select
                            options={(filteredPracticeListing.length > 0 ?
                                    filteredPracticeListing.map((item) => ({
                                        value: item.id.toString(),
                                        label: item.name
                                    }))
                                    : []
                            ) as unknown as OptionsOrGroups<string, GroupBase<string>>}
                            id="practice_id"
                            placeholder="Select Practice"
                            isSearchable={true}
                            {...field}
                            noOptionsMessage={() => "Please enter 2 or more characters to search..."}
                            onInputChange={debouncedFilterPractice}
                            onMenuClose={() => updatedFilteredPracticeListing([])}
                        />
                    )}
                />
            </div>
            <div className="col mb-2">
                <Controller
                    name="global_doctor_id"
                    control={control}
                    defaultValue={''}
                    render={({ field }) => (
                        <Select
                            isClearable={false}
                            options={(filteredDocListing.length > 0 ?
                                    filteredDocListing.map((item) => ({ value: item.id.toString(), label: item.name }))
                                    : []
                            ) as unknown as OptionsOrGroups<string, GroupBase<string>>}
                            id="global_doctor_id"
                            placeholder="Select Doctor"
                            isSearchable={true}
                            // placeholder="Enter Diagnosis Code"
                            {...field}
                            noOptionsMessage={() => "Please enter 2 or more characters to search..."}
                            onInputChange={debouncedFilterDoctor}
                            onMenuClose={() => updatedFilteredDocListing([])}
                        />
                    )}
                />
            </div>
            <div className="col date-field">
                <Controller
                    name="global_patient_id"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                        <HubInputField
                            inputId="global_patient_id"
                            isRowBased={true}
                            isRequired={false}
                            field={field}
                            inputPlaceholder="Pt. ID"
                        />
                    )}
                />
            </div>
            <div className="col date-field">
                <Controller
                    name="case_id"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                        <HubInputField
                            inputId="case_id"
                            isRowBased={true}
                            isRequired={false}
                            field={field}
                            inputPlaceholder="Case ID"
                        />
                    )}
                />
            </div>
            <div className="col btn-col mb-2">
                <div className="row g-2">
                    <div className="col-6">
                        <button type="submit" className="btn btn-primary w-100">
                            Filter
                        </button>
                    </div>
                    <div className="col-6">
                        <button type="button" onClick={clearFormData} className="btn btn-outline-secondary w-100">
                            Clear
                        </button>
                    </div>
                </div>
            </div>
        </form>
    );
};

export default ActionDashBoardFilter;
